(function ($) {
    $(function () {
        var $targetButton = $('.journal-retailer__button.site-cta-button');
        $targetButton.addClass('fc-sidecart--bypass');
        $targetButton.each(function() {
            $(this).prop('tabindex', '1');
        });

        $('.book-wrapper__top-section--image [data-featherlight]').featherlight($('.journal-subscribe-modal'), {
            afterOpen: function() {
                var journalSubscriptions = this.$content.find('.journal-retailer');

                journalSubscriptions.each(function() {
                    if( $(this).find('.journal-retailer__title').html() !== 'Institution Online Only' ) {
                        return;
                    }

                    var container = $('<div>').attr({
                        class: 'sub-institution__container'
                    }).appendTo($(this));


                    $('<input>').attr({
                        type: 'text',
                        class: 'sub-institution',
                        required: true,
                        placeholder: 'Subscribing Institution'
                    }).appendTo(container);
        
                    var buyBtn = $(this).find('.journal-retailer__button');
                    buyBtn.addClass('disabled');
                    var buyBtnhref = buyBtn.attr("href");
        
                    $('.sub-institution').on("input", function() {
                        var val = $(this).val();
                        // Print entered value in a div box
                        if( val !== '' ) {
                            buyBtn.removeClass('disabled');
                            buyBtn.attr("href", buyBtnhref + `&h:subscription_institution=${val}`);
                        } else {
                            buyBtn.addClass('disabled');
                            buyBtn.attr("href", buyBtnhref);
                        }
                    });
                });
        
            }
        });

        $(".journal-retailer-popup").on("click", '.journal-retailer__button.site-cta-button', function(e){
            e.preventDefault();
            FC.session.reset();
            $(this).addClass('loader');
            const href = $(this).attr('href');
            setTimeout(function(e) {
                window.location.href = href;
            }, 2000); 
        });
    });
})(jQuery);